import { render, staticRenderFns } from "./SignaturePill.vue?vue&type=template&id=2f90a84b"
import script from "./SignaturePill.vue?vue&type=script&lang=js"
export * from "./SignaturePill.vue?vue&type=script&lang=js"
import style0 from "./SignaturePill.vue?vue&type=style&index=0&id=2f90a84b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports